import { Nullable } from '../interfaces/common/i-generics';
import { MongoRecord } from '../interfaces/mongo/_base';
import { DaemonName } from './i-machine-daemons';

//* Differ from the types found in /machine-msg/i-health-check.ts, which are used for typing WS messages passed between machine and client

export interface IHealthCheck extends MongoRecord {
  category: string;
  tags: string[]; // generally either ['system_health_check_result'] or ['daemon_health_check_result', <submodule_name>]
  machineID: string;
  timestamp: number;
  // fw may post results for either individual Daemons or the entire system
  date: ISubmoduleHealthCheckData | ISystemHealthCheckData;
}
export interface ISubmoduleHealthCheckData {
  scope: string;
  sender: DaemonName;
  test_type: string;
  test_passed?: Nullable<boolean>;
  daemon_result: IHealthCheckSubmoduleCheckResult[];
}

export interface ISystemHealthCheckData {
  scope: string;
  test_type: string;
  system_result: ISystemHealthCheckResult;
}

export interface ISystemHealthCheckResult {
  sender_id?: Nullable<string>;
  send_time?: Nullable<number>;
  test_passed?: Nullable<boolean>;
  failed_submodules: Record<DaemonName, string[]>;
  warned_submodules: Record<DaemonName, string[]>;
  s3_image_paths: Record<DaemonName, string[]>;
  system_check_results_dict: Record<
    DaemonName,
    IHealthCheckSubmoduleCheckResponse
  >;
}

export enum HealthCheckStatus {
  Pass = 'pass',
  Warn = 'warn',
  Fail = 'fail',
  Unknown = 'unknown',
}

export interface IHealthSubcheck {
  status: HealthCheckStatus;
  message: string;
  check_type: string;
  failure_reasons: string[];
  event_id?: string;
  device?: string;
}

export interface IHealthCheckSubmoduleCheckResult {
  status: HealthCheckStatus;
  test_name: string;
  test_description: string;
  checks: IHealthSubcheck[];
  data: Record<string, any>;
}

export interface IHealthCheckSubmoduleCheckResponse {
  status: HealthCheckStatus;
  name: DaemonName;
  results: IHealthCheckSubmoduleCheckResult[];
}
